<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const props = defineProps<{ sitekey: string }>()
const emit = defineEmits<{ (e: 'token', value: string | null): void }>()

const el = ref<HTMLElement | null>(null)
let widgetId: string | null = null

declare global {
  interface Window {
    turnstile: {
      render: (el: HTMLElement, opts: Record<string, unknown>) => string
      remove: (id: string) => void
    }
  }
}

function renderWidget() {
  widgetId = window.turnstile.render(el.value!, {
    sitekey: props.sitekey,
    callback: (token: string) => emit('token', token),
    'expired-callback': () => emit('token', null),
    'error-callback': () => emit('token', null),
  })
}

onMounted(() => {
  if (window.turnstile) {
    renderWidget()
  } else {
    const script = document.querySelector('script[src*="turnstile"]')
    if (script) {
      script.addEventListener('load', renderWidget, { once: true })
    }
  }
})

onUnmounted(() => {
  if (widgetId) window.turnstile.remove(widgetId)
})
</script>

<template>
  <div ref="el"></div>
</template>
